<template>
  <a-config-provider :theme="{ token: { colorPrimary: '#f2b62a' } }">
    <section>
      <a-layout>
        <Header />
        <a-layout>
          <Sidebar />
          <a-layout-content class="layout-main" style="min-height: 80vh">
            <router-view></router-view>
          </a-layout-content>
        </a-layout>
        <Footer />
      </a-layout>
    </section>
  </a-config-provider>
</template>

<script>
import Header from "@/components/layouts/header/TheHeader.vue";
import Footer from "@/components/layouts/footer/TheFooter.vue";
import Sidebar from "@/components/layouts/sidebar/TheSidebar.vue";

export default {
  name: "App",

  components: {
    Header,
    Footer,
    Sidebar,
  },
};
</script>
<style lang="less" scoped>
.layout-main {
  background-color: @color-white;
  padding: 1rem;
}
</style>
